export default __webpack_public_path__ + "static/media/support-desk-mobile.e677afc0.png";